// extracted by mini-css-extract-plugin
export default {"section":"styles_section__5Tt6X","headingWrapper":"styles_headingWrapper__+vK85","heading":"styles_heading__Qk8zR","icon":"styles_icon__m6aVz"};